import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { Theme } from "@mira/types";

interface ThemeState {
  theme: Theme;
  resolvedTheme: "light" | "dark";
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
}

function normalizeTheme(theme: string | null | undefined): Theme {
  return theme === "dark" ? "dark" : "light";
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: "light",
      resolvedTheme: "light",
      setTheme: (theme) => {
        const resolved = normalizeTheme(theme);
        document.documentElement.setAttribute(
          "data-theme",
          resolved === "dark" ? "dark" : "light",
        );
        set({ theme: resolved, resolvedTheme: resolved });
      },
      toggleTheme: () => {
        const current = get().resolvedTheme;
        const next = current === "light" ? "dark" : "light";
        document.documentElement.setAttribute("data-theme", next);
        set({ theme: next, resolvedTheme: next });
      },
    }),
    {
      name: "mira-theme",
      onRehydrateStorage: () => (state) => {
        if (state) {
          const resolved = normalizeTheme(state.theme);
          document.documentElement.setAttribute(
            "data-theme",
            resolved === "dark" ? "dark" : "light",
          );
          state.theme = resolved;
          state.resolvedTheme = resolved;
        }
      },
    },
  ),
);
